// frontend/src/utils/api.js
import supabase from '../supabaseClient';

export const getAuthHeaders = async () => {
  const { data: { session } } = await supabase.auth.getSession();
  
  if (!session) {
    throw new Error('No hay sesión activa');
  }

  return {
    'Authorization': `Bearer ${session.access_token}`,
    'Content-Type': 'application/json'
  };
};

export const fetchAPI = async (url, options = {}) => {
  const headers = await getAuthHeaders();
  
  const response = await fetch(url, {
    ...options,
    headers: {
      ...headers,
      ...options.headers
    }
  });

  if (!response.ok) {
    if (response.status === 401) {
      // Token expirado, limpiar TODO y redirigir a login
      localStorage.removeItem('usuario');
      localStorage.removeItem('sesion');
      await supabase.auth.signOut(); // ✅ NUEVO: Forzar cierre en Supabase
      window.location.href = '/login';
    }
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};